// الموجة 6a (المؤسس، 26 سبتمبر): النسخة العربية من golf6App.nl.ts. أسماء أزرار Apple وGoogle كما
// يعرضها جهاز باللغة العربية ("إضافة إلى الشاشة الرئيسية"، "إضافة"، "تثبيت التطبيق").
export const appGolf6Ar = {
    tabletGuide: {
        title: 'هكذا تربط جهاز iPad باللوحة',
        intro: 'ثلاث خطوات، دقيقة تقريبًا. أبقِ هذه الصفحة مفتوحة.',
        step1Title: 'افتح Safari على جهاز iPad',
        step1Body: 'اكتب هذا العنوان في شريط العنوان:',
        copy: 'نسخ',
        copied: 'تم النسخ',
        copyLabel: 'انسخ العنوان {url}',
        step2Title: 'تعرض اللوحة رمزًا',
        step2Body: 'ثمانية أحرف، مثل ABCD-2345. اترك جهاز iPad كما هو.',
        step3Title: 'أدخل الرمز هنا',
        step3Body: 'اختر أيضًا الغرفة التي تُعلَّق فيها اللوحة. تظهر اللوحة خلال ثوانٍ.',
        enterCode: 'إدخال الرمز',
        orTitle: 'تفضّل ألا تكتب شيئًا؟',
        orBody: 'أنشئ رمز QR وامسحه بكاميرا جهاز iPad. تربط اللوحة نفسها.',
        qrButton: 'الربط برمز QR',
        tipsTitle: 'نصائح للوحة على الحائط',
        tips: [
            {
                title: 'أضف اللوحة إلى الشاشة الرئيسية',
                body: 'عندها تُفتح اللوحة بملء الشاشة من دون شريط العنوان. افعل ذلك قبل الربط: للتطبيق على الشاشة الرئيسية ذاكرته الخاصة ويُربط وحده.',
            },
            {
                title: 'القفل التلقائي: أبدًا',
                body: 'الإعدادات › شاشة العرض والإضاءة › القفل التلقائي › أبدًا. اترك جهاز iPad على الشاحن فتبقى الشاشة مضاءة.',
            },
            {
                title: 'الوصول الموجَّه',
                body: 'الإعدادات › تسهيلات الاستخدام › الوصول الموجَّه (جهاز iPad أقدم بنظام iOS 12: الإعدادات › عام › تسهيلات الاستخدام › الوصول الموجَّه): شغّله واختر رمزًا. افتح اللوحة واضغط زر الشاشة الرئيسية (أو الزر العلوي) ثلاث مرات بسرعة. هكذا يبقى الأطفال في اللوحة.',
            },
            {
                title: 'المس مرة واحدة من أجل الصوت',
                body: 'لا يشغّل جهاز iPad الصوت إلا بعد لمسة. المس اللوحة مرة واحدة بعد التشغيل، فتسمع الأذان والنداءات.',
            },
        ],
        homeScreenHow: 'كيف أضيفها إلى الشاشة الرئيسية؟',
    },
    qr: {
        title: 'الربط برمز QR',
        intro: 'يمسح جهاز iPad الرمز بالكاميرا ويربط نفسه. لا حاجة إلى الكتابة.',
        room: 'الغرفة',
        name: 'اسم الجهاز اللوحي',
        defaultName: 'iPad {room}',
        create: 'إنشاء رمز QR',
        scanTitle: 'امسح بكاميرا جهاز iPad',
        scanSteps: [
            'افتح تطبيق الكاميرا على جهاز iPad.',
            'وجّهها إلى هذا الرمز حتى يظهر إشعار في الأعلى.',
            'المس الإشعار. تُفتح اللوحة في Safari وتربط نفسها.',
        ],
        validFor: 'صالح لمدة {time} · يعمل مرة واحدة',
        qrLabel: 'رمز QR لربط جهاز لوحي في {room}',
        waiting: 'بانتظار أن يمسح جهاز iPad الرمز…',
        claimed: 'تم ربط {name}',
        claimedBody: 'اللوحة في {room} تعرض الآن التقويم.',
        expired: 'انتهت صلاحية رمز QR هذا',
        expiredBody: 'يعمل رمز QR لمدة 10 دقائق ومرة واحدة فقط. أنشئ رمزًا جديدًا.',
        again: 'رمز QR جديد',
        done: 'تم',
        safariNote: 'يفتح رمز QR اللوحة في Safari. هل اللوحة على الشاشة الرئيسية بالفعل؟ اربط ذلك التطبيق بالرمز إذن.',
        keepPrivate: 'لا تُرِ هذا الرمز للآخرين: من يمسحه يحصل على لوحة عائلتك.',
    },
    phoneQr: {
        title: 'افتح AMUMIN على هاتفك',
        body: 'امسح هذا الرمز بكاميرا هاتفك. ثم أضف AMUMIN إلى شاشتك الرئيسية.',
        label: 'رمز QR إلى {url}',
    },
    install: {
        platform: 'أي جهاز؟',
        ios: 'iPhone/iPad',
        android: 'Android',
        desktop: 'حاسوب',
        thisDevice: '{platform} (هذا الجهاز)',
        iosSteps: [
            'افتح {url} في Safari.',
            'المس مشاركة: المربع الصغير مع السهم إلى الأعلى. في iPhone يكون في الأسفل، وفي iPad في الأعلى بجانب العنوان. لا تراه؟ المس ··· أولًا.',
            'اسحب أو مرّر في قائمة المشاركة حتى ترى إضافة إلى الشاشة الرئيسية، ثم المسها. في جهاز iPad أقدم تكون في الصف السفلي: اسحب ذلك الصف إلى اليسار.',
            'المس إضافة في أعلى الشاشة.',
            'من الآن افتح {app} بالأيقونة على شاشتك الرئيسية.',
        ],
        androidSteps: [
            'افتح {url} في Chrome.',
            'المس النقاط الثلاث في أعلى الشاشة.',
            'اختر تثبيت التطبيق (أو إضافة إلى الشاشة الرئيسية).',
            'المس تثبيت. أصبح {app} بين تطبيقاتك.',
        ],
        desktopSteps: [
            'افتح {url} في Chrome أو Edge.',
            'انقر أيقونة التثبيت في طرف شريط العنوان (شاشة صغيرة مع سهم).',
            'انقر تثبيت. يُفتح {app} من الآن في نافذة خاصة به.',
        ],
        ui: {
            share: 'مشاركة',
            addToHome: 'إضافة إلى الشاشة الرئيسية',
            add: 'إضافة',
            cancel: 'إلغاء',
            installApp: 'تثبيت التطبيق',
            install: 'تثبيت',
        },
        pictureLabel: 'مثال على الخطوة {n}',
    },
    stepUp: {
        which: 'أدخل كلمة مرور AMUMIN الخاصة بك: نفسها التي تسجّل بها الدخول في {host}.',
        notThese: 'أي ليست كلمة مرور الواي فاي ولا رمز جهاز iPad.',
        why: 'نطلب ذلك عند الخطوات المهمة، مثل ربط جهاز لوحي. بعدها لن نسألك مجددًا لمدة 10 دقائق.',
        account: 'حسابك',
        password: 'كلمة مرور AMUMIN',
        forgot: 'نسيت كلمة المرور؟',
    },
    tasks: {
        forWho: 'لمن؟',
        forWhoHint: 'الأطفال محدّدون مسبقًا. المس اسمًا لإضافة شخص أو إزالته.',
        nobody: 'اختر شخصًا واحدًا على الأقل.',
    },
    werklijstDoc: {
        read: 'اقرأ النصيحة',
        readLabel: 'اقرأ النصيحة: {title}',
        loading: 'جارٍ تحميل النصيحة…',
        missing: 'هذه النصيحة ليست في هذا الإصدار من التطبيق بعد.',
        error: 'لا يمكن قراءة النصيحة الآن. حاول مرة أخرى لاحقًا.',
        back: 'رجوع',
        external: '(تُفتح في نافذة جديدة)',
    },
};
//# sourceMappingURL=golf6App.ar.js.map